package pl.mothdigital.neuronowi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.common.resources.StringResources
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.cta.*
import pl.mothdigital.neuronowi.components.sections.home.about.AboutSection
import pl.mothdigital.neuronowi.components.sections.home.contact.ContactSection
import pl.mothdigital.neuronowi.components.sections.home.hero.HeroSection
import pl.mothdigital.neuronowi.components.sections.offer.*
import pl.mothdigital.neuronowi.components.sections.team.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.theme.*

@Page
@Composable
fun HomePage() {
    val ctx = rememberPageContext()

    PageLayout(
        title = StringResources.HOME_PAGE_TITLE,
        description = StringResources.META_DESC_HOME,
        ogImage = "/hero_section.webp",
        backgroundColor = SiteTheme.white._900,
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            VerticalSpacer(78.px)
            HeroSection()
            OfferSection()
            CTASection(ctx)
            TeamSection(ctx)
            ContactSection()
        }
    }
}
